import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Signal } from '@phosphor/signaling';
/**
 * A concrete implementation of [[IObservableString]]
 */

export var ObservableString = /*#__PURE__*/function () {
  /**
   * Construct a new observable string.
   */
  function ObservableString() {
    var initialText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ObservableString);

    this._text = '';
    this._isDisposed = false;
    this._changed = new Signal(this);
    this._text = initialText;
  }
  /**
   * The type of the Observable.
   */


  _createClass(ObservableString, [{
    key: "insert",

    /**
     * Insert a substring.
     *
     * @param index - The starting index.
     *
     * @param text - The substring to insert.
     */
    value: function insert(index, text) {
      this._text = this._text.slice(0, index) + text + this._text.slice(index);

      this._changed.emit({
        type: 'insert',
        start: index,
        end: index + text.length,
        value: text
      });
    }
    /**
     * Remove a substring.
     *
     * @param start - The starting index.
     *
     * @param end - The ending index.
     */

  }, {
    key: "remove",
    value: function remove(start, end) {
      var oldValue = this._text.slice(start, end);

      this._text = this._text.slice(0, start) + this._text.slice(end);

      this._changed.emit({
        type: 'remove',
        start: start,
        end: end,
        value: oldValue
      });
    }
    /**
     * Set the ObservableString to an empty string.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.text = '';
    }
    /**
     * Test whether the string has been disposed.
     */

  }, {
    key: "dispose",

    /**
     * Dispose of the resources held by the string.
     */
    value: function dispose() {
      if (this._isDisposed) {
        return;
      }

      this._isDisposed = true;
      Signal.clearData(this);
      this.clear();
    }
  }, {
    key: "type",
    get: function get() {
      return 'String';
    }
    /**
     * A signal emitted when the string has changed.
     */

  }, {
    key: "changed",
    get: function get() {
      return this._changed;
    }
    /**
     * Set the value of the string.
     */

  }, {
    key: "text",
    set: function set(value) {
      if (value.length === this._text.length && value === this._text) {
        return;
      }

      this._text = value;

      this._changed.emit({
        type: 'set',
        start: 0,
        end: value.length,
        value: value
      });
    }
    /**
     * Get the value of the string.
     */
    ,
    get: function get() {
      return this._text;
    }
  }, {
    key: "isDisposed",
    get: function get() {
      return this._isDisposed;
    }
  }]);

  return ObservableString;
}();